import type { Scheduler } from '../types';

/**
 * Планировщик с батчингом через queueMicrotask.
 * Откладывает выполнение реакции до следующего микротика,
 * позволяя группировать несколько изменений источников данных в один запуск.
 */
export const tickScheduler: Scheduler = {
    schedule(execute) {
        queueMicrotask(execute);
    },
};
